var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPldGreenSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.895 10.912a5.333 5.333 0 11.952-.933l2.952 2.877a.666.666 0 11-.931.955l-2.973-2.899zm.772-4.245a4 4 0 10-8 0 4 4 0 008 0z",
    fill: "#4E8209"
  })));
}
export default SvgPldGreenSearch;